export const extractUserPermission = (data: any) => {
  const permission = data.data;

  if (!permission) {
    return {};
  }
  const permissionIAM = permission.getProductLibAppIAM;
  return permissionIAM;
};

export const extractPermissions = (data: any) => {
  const permissions = data.data.listProductLibAppIAM.items;

  if (!permissions) {
    return [];
  }

  return [...permissions];
};

export const extractPermission = (data: any) => {
  const permission = data.permission.data;

  if (!permission) {
    return {};
  }
  const permissionItems = permission.permissionByUsername.items;
  const firstPermission = permissionItems.length > 0 ? permissionItems[0] : {};
  const result = {
    ...firstPermission,
    approverBrandTypes: firstPermission.approverBrandTypes
      ? JSON.parse(firstPermission.approverBrandTypes)
      : [],
    editorBrandTypes: firstPermission.editorBrandTypes
      ? JSON.parse(firstPermission.editorBrandTypes)
      : [],
  };
  return result;
};

export const extractSearchProducts = (data: any) => {
  const products = data.data.searchProductLibProducts.items;

  if (!products) {
    return [];
  }

  return products.map((product: any) => ({
    value: product,
    label: product.name,
  }));
};

export const extractProduct = (data: any) => {
  const product = data.data;

  if (!product) {
    return {};
  }
  const productItem = product.getProductLibProduct;
  return productItem;
};

export const extractSearchFiles = (data: any) => {
  const files = data.data.searchProductLibFiles.items;
  if (!files) {
    return [];
  }
  return files;
};

export const extractBanner = (data: any) => {
  const banner = data.data;

  if (!banner) {
    return {};
  }
  const bannerItem = banner.getProductLibBanner;
  return bannerItem;
};